import { useEffect, useState } from 'react';
import { CustomSlide } from '../models/slides/CustomSlide';
import { PackageSlide } from '../models/slides/PackageSlide';
import { ProductSlide } from '../models/slides/ProductSlide';
import { EventSlide } from '../models/slides/EventSlide';
import { BaseSlide } from '../models/slides/BaseSlide';

export interface CarouselImages {
  url: string;
  type: string;
  backgroundImageUrl?: string;

  alt: string;
}

export const useCarouselImageRetriever = ({ slides }: { slides: BaseSlide[] }) => {
  const [images, setImages] = useState<CarouselImages[]>([]);

  useEffect(() => {
    if (!slides) return;
    const updatedImageUrls = slides.map((slider: BaseSlide, index) => {
      switch (slider.type) {
        case 'CUSTOM':
          const customSlide = slides[index] as CustomSlide;
          return { url: customSlide.image.url || '', alt: customSlide.image.alt || '', type: 'CUSTOM' };

        case 'PACKAGE':
          const packageSlide = slides[index] as PackageSlide;
          if (!packageSlide.showWineBottlesInFront) return { url: packageSlide.backgroundImage || '', alt: packageSlide.backgroundImage || '', type: 'PACKAGE' };
          return { url: packageSlide.foregroundImage || '', backgroundImageUrl: packageSlide.backgroundImage, alt: packageSlide.foregroundImage || '', type: 'PACKAGE' };

        case 'PRODUCT':
          const wineSlide = slides[index] as ProductSlide;
          return { url: wineSlide.imgUrl || '', alt: wineSlide.imgUrl || '', type: 'PRODUCT' };

        case 'EVENT':
          const eventSlide = slides[index] as EventSlide;
          return { url: eventSlide.image || '', alt: eventSlide.image || '', type: 'EVENT' };

        default:
          return { url: '', alt: '', type: '' };
      }
    });

    const filteredImages = updatedImageUrls.filter((obj) => obj !== null);
    setImages(filteredImages);
  }, [slides]);

  return { images };
};
